var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"inputRef",staticClass:"currency-input-style",on:{"focus":function($event){return $event.target.select()}}})}
var staticRenderFns = []

export { render, staticRenderFns }